import { render } from "./OnlineOrder.vue?vue&type=template&id=357b4fd7"
import script from "./OnlineOrder.vue?vue&type=script&lang=js"
export * from "./OnlineOrder.vue?vue&type=script&lang=js"

import "./OnlineOrder.vue?vue&type=style&index=0&id=357b4fd7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__